import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditTypeMasterModal = ({ isOpen, onClose, editFormData, setEditFormData }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
     if (!(editFormData.vType || '').trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Vehicle Type Name!',
          });
          return;
        }
    try {
        Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
      const response = await axios.put(`https://rfs2.infraconsoft.net.in/api/typeMaster_edit_api/${editFormData.id}`, {
        vType: editFormData.vType,
      });

      if (response.data.success) {
              Swal.fire({
                icon: "success",
                title: "Inserted!",
                text: "Vehicle Type Updated successfully.",
              });
              onClose();
              window.location.reload();
            } else {
              Swal.fire({
                icon: "error",
                title: "Update Failed",
                text: response.data.message || "Unknown error.",
              });
            }
        
           } catch (error) {
                      console.error("Error inserting location:", error);
                    
                      if (error.response && error.response.data && error.response.data.message) {
                        Swal.fire({
                          icon: "error",
                          title: "Insert Failed",
                          text: error.response.data.message,  // <-- duplicate message will show here
                        });
                      } else {
                        Swal.fire({
                          icon: "error",
                          title: "Error",
                          text: "Insert failed. Please try again.",
                        });
                      }
                    }
        };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Edit Vehicle Type </h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Type :</label>
                <input
            type="text"
            name="vType"
            value={editFormData.vType}
            onChange={handleEditChange}
          />
              </div>
              
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditTypeMasterModal;
